<template lang="pug">
  .gallery-inside
    .page__wr
      .gallery-inside__wr
        .gallery-inside__title-wr-wr
          router-link.gallery-inside__title-wr.title-oblique-line-anima(to="/galereya")
            h1.gallery-inside__title.title-anima
              | {{h1}}
          .gallery-inside__title-wr.title-oblique-line-anima(v-if="galleryTitle")
            h1.gallery-inside__title.title-anima
              | {{galleryTitle}}
        .gallery-inside__content
          .gallery-inside__slider.js-gallery-inside-slider
            .swiper-container(ref="swiperContainer")
              .swiper-wrapper(v-html="tmpl")

            .gallery-inside__slider-pagination-wr
              .swiper-button-prev
                SvgIcon(class='gallery-inside__slider-ico' name="arrow-left" width="7" height="11")
              .swiper-pagination(v-if='countOfSlideInPage > 2')
              .swiper-button-next
                SvgIcon(class='gallery-inside__slider-ico' name="arrow-left" width="7" height="11")

      .gallery-inside__bottom-nav
        .page__wr
           BottomNav(:links="links", :btn="btn")
        Samedia
</template>

<script>
import EventBus from '@/eventBus';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import BottomNav from '@/components/common/bottomNav/bottomNav.vue';
import Samedia from '@/components/common/samedia/Samedia.vue';

// @ is an alias to /src


import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';
import {determineWindowSize} from '@/mixins/determineWindowSize.js';

export default {
  name: 'GalleryInside',

  mixins: [AjaxHelpersVue, PopupHelpersVue, determineWindowSize],

  components: {
    BottomNav,
    SvgIcon,
    Samedia
  },

  data() {
    return {
      countOfSlideInPage: 0,
      links: {
        prev: {
          href: "/akcii",
          txt: "Акции"
        },
        next: {
          href: "/kontakty",
          txt: "Контакты"
        }
      },
      btn: false,
      tmpl: '',
      items: null,
      galleryTitle: ''
    }
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadGalleryInsidePage', url => {
      this.request(url);
    });
  },

  mounted() {
  },

  methods: {
    request(url) {
      this.req('GalleryInsidePage:getGalleryInsidePage', {url}, res => {
        if(this.checkProperty(res.content.items)) {
          this.generateSlidesTmpl(res.content.items);
        }

        if(this.checkProperty(res.content.galleryTitle)) {
          this.galleryTitle = res.content.galleryTitle;
        }

        this.determineWindowSize();
        EventBus.$emit('pageDone');
      }, 'gallery-inside');
    },

    generateSlidesTmpl(items) {
      let classes = [
        'gallery-inside__slider-img--big',
        'gallery-inside__slider-img--small-1',
        'gallery-inside__slider-img--small-2',
        'gallery-inside__slider-img--medium-1',
        'gallery-inside__slider-img--medium-2'
      ];

      let classesLength = classes.length;

      this.tmpl = '';

      items.forEach((el, i) => {
        let placeInArray = i % classesLength;

        // для big - одна картинка
        if(placeInArray === 0)
          this.tmpl += `<div class="swiper-slide"><div class="gallery-inside__slider-item">`;

        // для остальных картинок
        if(placeInArray >= 1 && placeInArray % 2) {
          this.tmpl += `<div class="swiper-slide"><div class="gallery-inside__slider-item">`;
        }

        this.tmpl += `
            <div data-src="${el.imgPreview}" data-fancybox="gallery-inside-slider" class="gallery-inside__slider-img ${classes[placeInArray]}" style="background-image: url('${el.imgFull}');"></div>
        `;

        // для big - одна картинка
        if(placeInArray === 0) {
          this.tmpl += `</div></div>`;
        }

        // для остальных картинок
        if(placeInArray >= 2 && !(placeInArray % 2)) {
          this.tmpl += `</div></div>`;
        }

        // для последней картики, если она одна в .gallery-inside__slider-item
        if((placeInArray % 2) && i === (items.length - 1)) {
          this.tmpl += `</div></div>`;
        }
      });

      this.$nextTick(() => {
        this.initSlider();
        this.initFancy();
      });
    },

    initSlider() {
      let $slider        = $('.js-gallery-inside-slider');
      let $sliderNextBtn = $slider.find('.swiper-button-next');
      let $sliderPrevBtn = $slider.find('.swiper-button-prev');
      let $sliderPagination = $slider.find('.swiper-pagination');

      if($slider.find('.swiper-slide-active').length) return;

      let sliderParams = {
        init: false,
        //autoplay: {
        //  delay: 5000
        //},
        slidesPerView: this.countOfSlideInPage,
        spaceBetween: 10,
        navigation: {
          nextEl: $sliderNextBtn,
          prevEl: $sliderPrevBtn
        },
        pagination: {
          el: $sliderPagination,
          type: 'bullets',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 10,
        },
        breakpoints: {
          1400: {
              pagination: {
                  dynamicMainBullets: 4,
              }
          }
        },
        //loop: true, // в цикле не работают события вью из-за клонирования слайдов без событий
        simulateTouch: true,
        observer: true, // если слайдер изначально скрыт
        observeParents: true // если слайдер изначально скрыт
      };

      if($slider.find('.gallery-inside__slider-item').length <= 3) {
        $.extend(sliderParams, {
          loop: false,
          virtualTranslate: true
        });

        $sliderNextBtn.hide();
        $sliderPrevBtn.hide();
        $sliderPagination.hide();
      }

      if($slider.length) {
        let swiper = new Swiper(this.$refs.swiperContainer, sliderParams);
        swiper.init();
      }
    },

    initFancy() {
      let $fancyEls = $('.js-gallery-inside-slider').find('[data-fancybox]');
      let btnTmpl = '<svg viewBox="0 0 21 38" id="arrow-left" width="12px" height="26px"><path d="M17.027 37.56L21 33.243 7.946 19.06 21 4.877 17.027.56 0 19.06z"></path></svg>';

      $fancyEls.fancybox({
        loop: true,
        infobar: false,
        smallBtn: true,
        toolbar: false,
        hash: false,
        btnTpl: {
          smallBtn:
          '<button data-fancybox-close class="fancybox-close-small">' +
          '<svg viewBox="0 0 31 31" id="close" width="32px" height="32px"><g fill-rule="evenodd"><path d="M2.772.41L30.35 27.989l-2.121 2.121L.65 2.532z"></path><path d="M.65 27.988L28.229.41l2.121 2.121L2.772 30.11z"></path></g></svg>' +
          '</button>',

          arrowLeft:
          '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
          + btnTmpl +
          '</button>',

          arrowRight:
          '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
          + btnTmpl +
          '</button>'
        }
      })
    }
  }
}
</script>
